// TODO: Безжалостно выпилить как только завершится эксперимент SPEC-348

export const EXPERIMENT_NAME_NODE = 'placementButtonExperiment.name';
export const EXPERIMENTAL_GROUP_NAME_NODE = 'placementButtonExperiment.experimentalGroupName';
export const EXPERIMENTAL_GROUP_TEXT_NODE = 'placementButtonExperiment.experimentalText';
export const EXPERIMENTAL_GROUP_URL_NODE = 'placementButtonExperiment.experimentalURL';
export const CONTROL_GROUP_TEXT_NODE = 'placementButtonExperiment.controlText';
export const CONTROL_GROUP_URL_NODE = 'placementButtonExperiment.controlURL';
